import { Button, Divider, styled } from "@mui/material";
import colors from "../../../theme/themeConstants";
import { StyledAddCollectionButton } from "../../buttons/AddCollectionButton";
import UploadMoveBack from "../UploadMoveBack";
import { UploadContainer } from "./UploadFirstStep";
import { useCallback } from "react";
import { metrics } from "utils/metrics";

interface IProps {
  next: () => void;
  back: () => void;
  setSexuality: (sex: string) => void;
  selectedSexuality: string;
}

const options = ["straight", "trans", "gay", "fluid", "lesbian", "animated"];

const UploadSecondStep = (props: IProps) => {
  const { next, back, setSexuality, selectedSexuality } = props;

  const handleClick = (value: string) => {
    setSexuality(value);
  };

  const isSelected = (value: string, selected: string) => {
    if (value === selected) {
      return true;
    } else {
      return false;
    }
  };

  const handleNext = useCallback(async () => {
    await metrics.sendUploadAudienceDefined();
    next();
  }, [next]);

  return (
    <UploadContainer sx={{ "@media screen and (max-width: 767px)": { paddingBottom: 0 } }}>
      <UploadMoveBack back={back} text="Define your Intended Audience"/>
      <Block>
        <UploadLabel>Select the audience that would enjoy this content:</UploadLabel>
        <FlexContainer>
          <InnerFlex>
            {options.map((el, index) => (
              (index % 2 === 0) && (
                <Option key={el}>
                  <p>{el}</p>
                  <StyledAddCollectionButton
                    onClick={() => handleClick(el)}
                    isButtonActive={isSelected(el, selectedSexuality)}
                  >
                  </StyledAddCollectionButton>
                </Option>
              )
            ))}
          </InnerFlex>
          <Divider
            style={{ width: "1px", height: "130px", background: "white", opacity: 0.14 }}
            sx={{
              "@media screen and (max-width: 767px)": {
                display: "none"
              }
            }}
          />
          <InnerFlex>
            {options.map((el, index) => (
              (Math.abs(index % 2) === 1) && (
                <Option key={el}>
                  <p>{el}</p>
                  <StyledAddCollectionButton
                    onClick={() => handleClick(el)}
                    isButtonActive={isSelected(el, selectedSexuality)}
                  >
                  </StyledAddCollectionButton>
                </Option>
              )
            ))}
          </InnerFlex>
        </FlexContainer>
      </Block>
      <Button variant="contained" fullWidth sx={{
        background: colors.purpleGradient,
        minHeight: "3rem",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "38px",
        fontFamily: "Poppins",
        marginTop: "24px"
      }} onClick={handleNext} disabled={selectedSexuality.length < 1}>
        Next
      </Button>
    </UploadContainer>
  );
};

export default UploadSecondStep;

const UploadLabel = styled("p")({
  fontWeight: 500,
  fontSize: "16px",
  opacity: 0.8
});

const Block = styled("div")({
  marginTop: "2rem",
  textAlign: "left",
  "@media screen and (max-width: 330px)": {
    marginTop: "0.5rem"
  }
});

const FlexContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  gap: "2rem",
  width: "100%",
  marginTop: "24px",
  marginBottom: "1rem",
  "@media screen and (max-width: 767px)": {
    flexDirection: "column",
    gap: "1rem"
  }
});

const InnerFlex = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "48%",
  gap: "1rem",
  "@media screen and (max-width: 767px)": {
    width: "100%"
  }
});

const Option = styled("div")({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& p": {
    fontWeight: 500,
    fontSize: "14px",
    textTransform: "capitalize !important",
  }
});
